<template>
    <div
        class="support-widget"
        :class="{
            is_product_page: isProductPage,
            is_catalog_page: isCatalogPage,
        }"
        v-click-outside="() => (isShow = false)"
        v-bsl="isShow && !$device.isDesktop">
        <template v-if="$device.isDesktop">
            <div class="main__button" @click="isShow = !isShow"></div>
            <div class="socials" v-if="isShow && $device.isDesktop">
                <a href="https://wa.me/79399006343" target="_blank" @click="isShow = false" class="socials__item">
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M20.5703 4.76075L20.5727 4.76316C22.6706 6.86105 23.8253 9.65165 23.8253 12.6259C23.8253 18.749 18.8332 23.7411 12.71 23.7411C10.8489 23.7411 9.02058 23.2701 7.39367 22.3838L7.15818 22.2554L6.89881 22.3236L1.78314 23.6683L3.1416 18.6808L3.21524 18.4105L3.07586 18.1674C2.11071 16.484 1.59484 14.577 1.59484 12.614C1.59484 6.49083 6.58692 1.49875 12.71 1.49876L12.7124 1.49875C14.1731 1.49366 15.6203 1.77948 16.9694 2.33953C18.3185 2.89958 19.5426 3.72265 20.5703 4.76075Z"
                            stroke="black"
                            stroke-width="1.35088" />
                        <path
                            d="M15.7911 12.842L15.7743 12.8352L15.7572 12.8292C15.7527 12.8277 15.7479 12.826 15.7427 12.8241C15.6388 12.7877 15.4056 12.7058 15.1499 12.7342C14.809 12.7721 14.5696 12.9729 14.4086 13.2L14.4085 13.2L14.4013 13.2107C14.2847 13.382 13.9784 13.7553 13.7814 13.9886C13.7623 13.9803 13.7422 13.9716 13.7212 13.9625C13.3628 13.8074 12.7446 13.5399 12.0074 12.8813L12.0069 12.8809C11.455 12.3887 11.0477 11.7971 10.8342 11.459C10.9117 11.372 10.9937 11.273 11.0593 11.1938C11.0933 11.1527 11.1229 11.117 11.1451 11.0911C11.3147 10.8932 11.4016 10.7176 11.4723 10.5748C11.4794 10.5603 11.4864 10.5461 11.4934 10.5323L11.497 10.5251L11.5004 10.5178C11.7065 10.08 11.5816 9.70375 11.4729 9.48638C11.4736 9.48766 11.4732 9.4868 11.4716 9.48321C11.4684 9.47607 11.4603 9.45811 11.4458 9.42467C11.4268 9.3806 11.4018 9.32188 11.3722 9.25135C11.313 9.11058 11.2373 8.92792 11.1566 8.73207C10.9952 8.34019 10.8162 7.90058 10.7146 7.64654L10.7147 7.64651L10.711 7.6376C10.5766 7.3153 10.3826 7.03533 10.0729 6.88656C9.81743 6.76384 9.47474 6.77615 9.55678 6.78162L9.53435 6.78013H9.51187H9.01847C8.68659 6.78013 8.22737 6.89912 7.84304 7.31676L7.83798 7.32225L7.83305 7.32785C7.81707 7.346 7.79786 7.36701 7.77595 7.39096C7.4966 7.69633 6.78062 8.47902 6.78062 9.90133C6.78062 10.6764 7.05789 11.4002 7.32246 11.9227C7.5857 12.4426 7.86558 12.8195 7.94667 12.9277L7.95317 12.9372L7.97836 12.9739C7.9989 13.0039 8.02599 13.0432 8.05922 13.0905C8.12569 13.1851 8.21607 13.3109 8.32894 13.4597C8.55437 13.7571 8.8703 14.1478 9.26626 14.5694C10.0515 15.4053 11.1808 16.3937 12.5724 16.9946C13.2083 17.2746 13.7063 17.4371 14.0896 17.5543C14.8322 17.7922 15.501 17.7495 15.9885 17.6815L15.9885 17.6815L15.9926 17.6809C16.3672 17.6263 16.8369 17.4214 17.2266 17.171C17.5982 16.9321 18.0672 16.5442 18.2484 16.0256C18.3752 15.6742 18.4418 15.3426 18.4647 15.069C18.4762 14.9324 18.4777 14.7992 18.4664 14.678C18.4582 14.5896 18.4355 14.3975 18.3255 14.2246L17.7557 14.5873L18.3255 14.2246C18.1942 14.0183 18.0112 13.9098 17.9008 13.851C17.838 13.8176 17.7446 13.7744 17.6645 13.7373C17.6268 13.7198 17.592 13.7037 17.5648 13.6906C17.5136 13.6661 17.408 13.6147 17.2723 13.5485C16.8064 13.3215 15.9852 12.9214 15.7911 12.842Z"
                            stroke="black"
                            stroke-width="1.35088" />
                    </svg>
                    <div class="tooltip">{{ $t("написать в whatsapp") }}</div>
                </a>
                <a :href="'tel:' + phone" class="socials__item" @click="isShow = false">
                    <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M18.0419 13.0941C18.5145 13.2828 21.1352 14.5403 21.6722 14.7918C22.2092 15.0433 22.5315 15.1481 22.6818 15.3787C22.8322 15.6092 22.8322 16.6362 22.3811 17.8518C21.9515 19.0675 19.8248 20.1783 18.7937 20.325C17.87 20.4508 16.7101 20.5137 15.4427 20.1154C14.6694 19.8849 13.6812 19.5705 12.4138 19.0256C7.08651 16.7829 3.58508 11.5431 3.32731 11.1868L3.32313 11.1814C3.04959 10.8256 1.15771 8.36493 1.15771 5.82129C1.15771 3.26427 2.53251 2.00672 3.00509 1.48274C3.49916 0.958763 4.05767 0.833008 4.42285 0.833008H5.45394C5.77616 0.853967 6.22726 0.728213 6.65689 1.73425C7.08651 2.78221 8.16057 5.33923 8.28945 5.59074C8.41834 5.84225 8.50426 6.13567 8.33242 6.49198C8.16057 6.82733 8.05316 7.05788 7.79539 7.35131C7.53761 7.64473 7.23688 8.022 7.00058 8.25255C6.72133 8.52502 6.46356 8.79749 6.76429 9.32147C7.08651 9.84545 8.13908 11.5431 9.72869 12.9264C11.7479 14.687 13.4664 15.2529 14.0034 15.5044C14.5405 15.7769 14.8627 15.735 15.1634 15.3787C15.4642 15.0433 16.4738 13.8696 16.8389 13.3456C17.2041 12.8426 17.5478 12.9264 18.0419 13.0941Z"
                            stroke="black"
                            stroke-width="1.35088" />
                    </svg>
                    <div class="tooltip">{{ $t("позвонить менеджеру") }}</div>
                </a>
                <a href="https://t.me/pps_clients" target="_blank" @click="isShow = false" class="socials__item">
                    <svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M24.4997 0.782227L0.823242 9.23811L8.07893 12.8806L17.6259 7.02657L11.134 15.2223L21.1174 21.0763L24.4997 0.782227Z"
                            stroke="black"
                            stroke-width="1.35088"
                            stroke-linejoin="round" />
                    </svg>
                    <div class="tooltip">{{ $t("написать в telegram") }}</div>
                </a>
                <a href="https://max.ru/id7702704924_bot" target="_blank" @click="isShow = false" class="socials__item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 720 720">
                        <defs>
                            <!-- Define the original shape as a clipPath -->
                            <clipPath id="clip-inner-d">
                                <path
                                    d="M350.4,9.6C141.8,20.5,4.1,184.1,12.8,390.4c3.8,90.3,40.1,168,48.7,253.7,2.2,22.2-4.2,49.6,21.4,59.3,31.5,11.9,79.8-8.1,106.2-26.4,9-6.1,17.6-13.2,24.2-22,27.3,18.1,53.2,35.6,85.7,43.4,143.1,34.3,299.9-44.2,369.6-170.3C799.6,291.2,622.5-4.6,350.4,9.6h0ZM269.4,504c-11.3,8.8-22.2,20.8-34.7,27.7-18.1,9.7-23.7-.4-30.5-16.4-21.4-50.9-24-137.6-11.5-190.9,16.8-72.5,72.9-136.3,150-143.1,78-6.9,150.4,32.7,183.1,104.2,72.4,159.1-112.9,316.2-256.4,218.6h0Z"></path>
                            </clipPath>
                        </defs>
                        <path
                            stroke="currentColor"
                            stroke-width="70"
                            fill="none"
                            clip-path="url(#clip-inner-d)"
                            d="M350.4,9.6C141.8,20.5,4.1,184.1,12.8,390.4c3.8,90.3,40.1,168,48.7,253.7,2.2,22.2-4.2,49.6,21.4,59.3,31.5,11.9,79.8-8.1,106.2-26.4,9-6.1,17.6-13.2,24.2-22,27.3,18.1,53.2,35.6,85.7,43.4,143.1,34.3,299.9-44.2,369.6-170.3C799.6,291.2,622.5-4.6,350.4,9.6h0ZM269.4,504c-11.3,8.8-22.2,20.8-34.7,27.7-18.1,9.7-23.7-.4-30.5-16.4-21.4-50.9-24-137.6-11.5-190.9,16.8-72.5,72.9-136.3,150-143.1,78-6.9,150.4,32.7,183.1,104.2,72.4,159.1-112.9,316.2-256.4,218.6h0Z"></path>
                    </svg>
                    <div class="tooltip">{{ $t("написать в max") }}</div>
                </a>
            </div>
        </template>
        <template v-else>
            <div class="backdrop" v-if="isShow" @click="isShow = false"></div>
            <div
                class="main__button"
                :class="{ is_product_page: isProductPage, is_catalog_page: isCatalogPage }"
                @click="isShow = !isShow"
                v-if="!isShow"></div>
            <div class="socials-m" v-else-if="isShow && !$device.isDesktop">
                <div class="social__items">
                    <a href="https://wa.me/79399006343" @click="isShow = false" target="_blank" class="socials__item">
                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.0216 2.98399L15.0233 2.98577C16.6208 4.58323 17.5 6.70821 17.5 8.97292C17.5 13.6355 13.6987 17.4367 9.03618 17.4367C7.61899 17.4367 6.22678 17.0781 4.98796 16.4032L4.81363 16.3082L4.62163 16.3587L0.70985 17.3869L1.74876 13.5727L1.80327 13.3725L1.7001 13.1926C0.965178 11.9107 0.572362 10.4587 0.572362 8.96387C0.572362 4.30132 4.37363 0.500054 9.03618 0.500057L9.03792 0.500051C10.1502 0.496176 11.2522 0.713818 12.2795 1.14028C13.3069 1.56675 14.239 2.1935 15.0216 2.98399Z"
                                stroke="black" />
                            <path
                                d="M11.403 9.17703L11.3906 9.17196L11.3779 9.16756C11.3745 9.16638 11.3709 9.16511 11.367 9.16375C11.2879 9.13599 11.1131 9.07468 10.9217 9.09594C10.6675 9.12418 10.4884 9.27388 10.3674 9.44466L10.3674 9.44461L10.362 9.45251C10.2715 9.58561 10.032 9.87699 9.88224 10.0542C9.86481 10.0465 9.84631 10.0385 9.82678 10.0301C9.55394 9.91205 9.0811 9.70748 8.51793 9.20436L8.51757 9.20404C8.09095 8.82363 7.7776 8.36564 7.61634 8.10929C7.67694 8.0417 7.742 7.96314 7.79392 7.90045C7.82001 7.86895 7.84279 7.84145 7.86001 7.82136C7.988 7.67209 8.05343 7.53983 8.1072 7.43114C8.11266 7.42011 8.11801 7.40931 8.12328 7.39877L8.12341 7.39883L8.12848 7.38806C8.28285 7.0601 8.18939 6.7785 8.10763 6.615C8.10812 6.616 8.10786 6.61542 8.1067 6.61284C8.10431 6.60751 8.09807 6.59364 8.08676 6.56747C8.07222 6.53385 8.05321 6.48908 8.03063 6.43536C7.98556 6.32813 7.92786 6.18902 7.86644 6.03989C7.74353 5.74148 7.60725 5.40671 7.52984 5.21322L7.52988 5.2132L7.52714 5.2066C7.42552 4.96279 7.27965 4.75326 7.04831 4.64213C6.85711 4.55028 6.60147 4.55967 6.66058 4.56361L6.64397 4.5625H6.62733H6.25165C6.00228 4.5625 5.65668 4.65189 5.36718 4.96648L5.36709 4.9664L5.35978 4.9747C5.34759 4.98855 5.33294 5.00457 5.31626 5.0228C5.10386 5.25502 4.56201 5.84739 4.56201 6.92473C4.56201 7.5117 4.77205 8.06044 4.97304 8.45739C5.17309 8.85251 5.38582 9.13887 5.44717 9.2207L5.45231 9.22817L5.47148 9.25617C5.4871 9.27895 5.5077 9.30883 5.53296 9.34479C5.58349 9.41672 5.6522 9.5123 5.73802 9.6255C5.90943 9.85158 6.14966 10.1487 6.45073 10.4692C7.04794 11.105 7.90621 11.8561 8.96331 12.3125C9.44689 12.5254 9.82559 12.649 10.1172 12.7382C10.6797 12.9184 11.1865 12.8861 11.5567 12.8345L11.5567 12.8345L11.5598 12.834C11.8423 12.7929 12.198 12.6379 12.4937 12.4479C12.776 12.2665 13.1296 11.9733 13.266 11.583C13.3621 11.3166 13.4125 11.0653 13.4299 10.8582C13.4386 10.7548 13.4397 10.6543 13.4312 10.5631C13.425 10.4961 13.4079 10.3527 13.326 10.2242C13.2281 10.0703 13.0915 9.98908 13.008 9.94469C12.9606 9.91944 12.8903 9.88691 12.8296 9.85878C12.8006 9.84537 12.7738 9.83297 12.7527 9.82283C12.7135 9.80402 12.6328 9.76467 12.529 9.71414C12.1741 9.54121 11.5503 9.23727 11.403 9.17703Z"
                                stroke="black" />
                        </svg>
                        <div>{{ $t("написать в whatsapp") }}</div>
                    </a>
                    <div class="line"></div>
                    <a :href="'tel:' + phone" @click="isShow = false" class="socials__item">
                        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.061 10.8589C15.4546 11.0105 17.6371 12.0217 18.0843 12.2239C18.5315 12.4262 18.7999 12.5104 18.9251 12.6958C19.0503 12.8812 19.0503 13.707 18.6747 14.6844C18.3169 15.6619 16.5458 16.5551 15.6871 16.6731C14.9179 16.7742 13.9519 16.8247 12.8964 16.5045C12.2524 16.3191 11.4295 16.0664 10.374 15.6282C5.93745 13.8249 3.02149 9.61175 2.80682 9.32526L2.80334 9.32088C2.57554 9.03481 1 7.05623 1 5.01095C1 2.95492 2.14492 1.94375 2.53848 1.52244C2.94994 1.10112 3.41506 1 3.71918 1H4.57787C4.84621 1.01685 5.22188 0.915737 5.57967 1.72467C5.93745 2.56731 6.83192 4.62334 6.93926 4.82557C7.04659 5.02781 7.11815 5.26374 6.97504 5.55024C6.83192 5.81988 6.74247 6.00526 6.5278 6.2412C6.31313 6.47714 6.06268 6.78049 5.8659 6.96587C5.63333 7.18496 5.41866 7.40404 5.66911 7.82536C5.93745 8.24668 6.81403 9.61175 8.13784 10.724C9.81944 12.1397 11.2506 12.5947 11.6978 12.7969C12.1451 13.016 12.4134 12.9823 12.6638 12.6958C12.9143 12.4262 13.7551 11.4824 14.0592 11.0611C14.3633 10.6566 14.6496 10.724 15.061 10.8589Z"
                                stroke="black" />
                        </svg>
                        <div>{{ $t("позвонить менеджеру") }}</div>
                    </a>
                    <div class="line"></div>
                    <a href="https://t.me/pps_clients" @click="isShow = false" target="_blank" class="socials__item">
                        <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19 1L1 7.42857L6.51613 10.1978L13.7742 5.74725L8.83871 11.978L16.4286 16.4286L19 1Z"
                                stroke="black"
                                stroke-linejoin="round" />
                        </svg>
                        <div>{{ $t("написать в telegram") }}</div>
                    </a>
                    <div class="line"></div>
                    <a
                        href="https://max.ru/id7702704924_bot"
                        @click="isShow = false"
                        target="_blank"
                        class="socials__item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 720 720">
                            <defs>
                                <!-- Define the original shape as a clipPath -->
                                <clipPath id="clip-inner-m">
                                    <path
                                        d="M350.4,9.6C141.8,20.5,4.1,184.1,12.8,390.4c3.8,90.3,40.1,168,48.7,253.7,2.2,22.2-4.2,49.6,21.4,59.3,31.5,11.9,79.8-8.1,106.2-26.4,9-6.1,17.6-13.2,24.2-22,27.3,18.1,53.2,35.6,85.7,43.4,143.1,34.3,299.9-44.2,369.6-170.3C799.6,291.2,622.5-4.6,350.4,9.6h0ZM269.4,504c-11.3,8.8-22.2,20.8-34.7,27.7-18.1,9.7-23.7-.4-30.5-16.4-21.4-50.9-24-137.6-11.5-190.9,16.8-72.5,72.9-136.3,150-143.1,78-6.9,150.4,32.7,183.1,104.2,72.4,159.1-112.9,316.2-256.4,218.6h0Z"></path>
                                </clipPath>
                            </defs>
                            <path
                                stroke="currentColor"
                                stroke-width="70"
                                fill="none"
                                clip-path="url(#clip-inner-m)"
                                d="M350.4,9.6C141.8,20.5,4.1,184.1,12.8,390.4c3.8,90.3,40.1,168,48.7,253.7,2.2,22.2-4.2,49.6,21.4,59.3,31.5,11.9,79.8-8.1,106.2-26.4,9-6.1,17.6-13.2,24.2-22,27.3,18.1,53.2,35.6,85.7,43.4,143.1,34.3,299.9-44.2,369.6-170.3C799.6,291.2,622.5-4.6,350.4,9.6h0ZM269.4,504c-11.3,8.8-22.2,20.8-34.7,27.7-18.1,9.7-23.7-.4-30.5-16.4-21.4-50.9-24-137.6-11.5-190.9,16.8-72.5,72.9-136.3,150-143.1,78-6.9,150.4,32.7,183.1,104.2,72.4,159.1-112.9,316.2-256.4,218.6h0Z"></path>
                        </svg>
                        <div>{{ $t("написать в max") }}</div>
                    </a>
                </div>
                <div class="button" @click="isShow = false">{{ $t("cancel") }}</div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "SupportWidget",
    data() {
        return {
            isShow: false,
            phone: "+79399006343",
        };
    },
    computed: {
        isCatalogPage() {
            return this.$route.name?.includes("catalog") || this.$route.name === "drops-slug" || false;
        },
        isProductPage() {
            return this.$route.name === "product-slug";
        },
    },
};
</script>

<style scoped lang="less">
.support-widget {
    position: fixed;
    bottom: 30px;
    right: 30px;
    z-index: 1000;
    @media (max-width: 750px) {
        bottom: 30px;
        &.is_product_page {
            bottom: 125px;
            z-index: 5;
            right: 16px;
        }
        &.is_catalog_page {
            bottom: 190px;
            z-index: 10;
            right: 16px;
        }
    }
    .backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1000;
        background: rgba(0, 0, 0, 0.2);
    }
    .main__button {
        padding: 12px;
        background-color: black;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        svg {
            width: 28px;
            height: 26px;
            //&:last-child{
            //  display: none;
            //}
        }
    }
    .socials {
        position: absolute;
        z-index: 1000;
        bottom: 100%;
        right: 4px;
        margin-bottom: 16px;
        display: flex;
        flex-direction: column;
        gap: 11px;
        .socials__item {
            width: 46px;
            height: 46px;
            border-radius: 50%;
            background-color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            .tooltip {
                display: none;
                position: absolute;
                right: 120%;
                background-color: black;
                color: white;
                padding: 5px 10px;
                border-radius: 8px;
                white-space: nowrap;
            }
            .tooltip::after {
                content: "";
                position: absolute;
                top: 50%;
                left: 100%;
                margin-top: -5px;
                border-width: 5px;
                border-style: solid;
                border-color: transparent transparent transparent black;
            }
            &:hover {
                .tooltip {
                    display: block;
                }
            }
        }
    }
    .socials-m {
        position: fixed;
        bottom: 60px;
        left: 0;
        right: 0;
        padding: 0 40px;
        z-index: 1001;
        .social__items {
            border-radius: 12px;
            backdrop-filter: blur(10px);
            background-color: rgba(255, 255, 255, 0.6);
            display: flex;
            flex-direction: column;
            margin-bottom: 7px;
            .line {
                border-bottom: 1px solid rgba(0, 0, 0, 0.2);
            }
            .socials__item {
                padding: 16px;
                display: flex;
                gap: 17px;
                align-items: center;
                font-size: 16px;
            }
        }
        .button {
            width: 100%;
            height: 40px;
            background-color: #ffffff;
            border: none;
            border-radius: 12px;
            font-weight: bold;
            font-size: 16px;
        }
    }
}
// .support-widget.desktop-leav {
//     position: fixed;
//     right: 0;
//     bottom: 25px;
//     z-index: 100;
//     width: 155px;
//     height: 170px;
// }
.support-widget .main__button:after {
    content: url(~assets/img/svg/manager-widget/heart.svg);
    height: 25px;
    animation-name: rotate;
    animation-duration: 5s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes rotate {
    0% {
        transform: rotateY(360deg);
    }
    25% {
        content: url(~assets/img/svg/manager-widget/message.svg);
    }
    50% {
        transform: rotateY(0);
    }
    100% {
        transform: rotateY(360deg);
    }
}
</style>
